import { Fragment, useEffect, useState } from "react";
import { TValidCardAttachment } from "../..";
// import { Trello } from "../../../../@types/my-trello-types";
import AttachedCard from "./_attached-card";
import CardsGroup from "../shared/cards-group/cards-group";
import { useTrelloPowerUpContext } from "../../../../../external/trello-pu__core/trello-iframe/context";
import { Trello } from "../../../../../external/trello-pu__core/trello-iframe/trello";
// import useTrelloRestApi from "../../../modal/hooks/use-trello-rest-api";
// import trelloIFrame from "../../../shared/trello-client/trello-iframe";

type TCardGroupsDict = {
  [idBoard: string]: TValidCardAttachment[];
};

type TProps = {
  cards: TValidCardAttachment[];
  boardsWithTargets: string[];
  shortLinkCurrentCard: string;
  collapsedBoardsIds: string[];
  onConnectClick(idTargetCard: string): void;
  onRemoveClick(idAttachment: string): void;
  onGroupCollapsedToggle(idBoard: string): void;
};

const ValidCardsList = (props: TProps) => {
  const [membersBoards, setMembersBoards] = useState<string[]>([]);

  const { trelloIFrame, restApi } = useTrelloPowerUpContext();

  const idMember = trelloIFrame.getContext().member;
  const idCurrentBoard = trelloIFrame.getContext().board;

  useEffect(() => {
    // const idMember = trelloIFrame.getContext().member;
    restApi
      .fetchAllBoardsForMember(idMember)
      .then((boards) => setMembersBoards(boards.map((b) => b.id)));
  }, []);

  const getValidCardsGroups = () => {
    const groupsDict: TCardGroupsDict = {};

    props.cards
      .filter((vc): vc is TValidCardAttachment => !!vc.card.idBoard)
      .forEach((vc) =>
        groupsDict[vc.card.idBoard]
          ? groupsDict[vc.card.idBoard].push(vc)
          : (groupsDict[vc.card.idBoard] = [vc])
      );

    return Object.keys(groupsDict).map((idBoard) => {
      const board = groupsDict[idBoard][0].card.board as Trello.Board;
      const boardImage = board.prefs.backgroundImageScaled?.[2].url;
      const boardColor =
        board.prefs.backgroundColor ?? board.prefs.backgroundBottomColor;

      const attachedCardsArray = groupsDict[idBoard].map((c, idx) => (
        <AttachedCard
          key={c.card.id + idx}
          validCard={c}
          isWritableByUser={membersBoards.some((b) => b === idBoard)}
          shortLinkCurrentCard={props.shortLinkCurrentCard}
          onConnectCardsRequest={props.onConnectClick}
          onRemoveAttachmentRequest={props.onRemoveClick}
        />
      ));

      return (
        <CardsGroup
          key={idBoard}
          isCollapsed={props.collapsedBoardsIds.some((b) => b == idBoard)}
          onToggleCollapsedClick={() => props.onGroupCollapsedToggle(idBoard)}
          withTargets={props.boardsWithTargets.some((b) => b == idBoard)}
          inTargetDoneCount={
            groupsDict[idBoard].filter((c) => c.targetList == "done").length
          }
          inTargetWIPCount={
            groupsDict[idBoard].filter((c) => c.targetList == "wip").length
          }
          boardColor={boardColor}
          boardImage={boardImage}
          boardName={board.name}
        >
          {attachedCardsArray}
        </CardsGroup>
      );
    });
  };

  const validGroupsSorted = getValidCardsGroups().sort((a, b) => {
    //ToDo: Move idBoard to dedicated prop
    return a.key == idCurrentBoard
      ? -1 // key holds idBoard (see <CardsGroup key=...>)
      : b.key == idCurrentBoard
      ? 1
      : a.props.boardName.localeCompare(b.props.boardName);
  });

  return <Fragment>{validGroupsSorted}</Fragment>;
};

export default ValidCardsList;
